import { render, staticRenderFns } from "./GSTDriverMaster.vue?vue&type=template&id=236c1f54&scoped=true"
import script from "./GSTDriverMaster.vue?vue&type=script&lang=js"
export * from "./GSTDriverMaster.vue?vue&type=script&lang=js"
import style0 from "./GSTDriverMaster.vue?vue&type=style&index=0&id=236c1f54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236c1f54",
  null
  
)

export default component.exports